module.exports = __webpack_public_path__ + "./assets/fonts/proximanova-regular-webfont.woff2";